<template>
  <div id="OrderNetworkCoverageSummary" class="detailContainer">
    <div class="contentSummary">
      <div
        v-if="!viewSubmit && Object.keys(item).length > 0"
        :class="{ padding60: !IsMobile() }"
      >
        <div class="mdl-grid">
          <div class="mdl-cell mdl-cell--12-col">
            <MyHeaderPage
              :title="$t('crossConnects.detailTitle')"
              :subtitle="$t('crossConnects.detailSubTitle')"
            />
          </div>
        </div>
        <div class="infoKit">
          <div class="mdl-grid">
            <div
              class="mdl-cell mdl-cell--5-col mdl-cell--12-col-tablet mdl-cell--12-col-phone"
            >
              <div class="mdl-cell mdl-cell--12-col">
                <div class="summaryItem">
                  <div class="contentImage">
                    <img
                      src="@/assets/img/icon_info.png"
                      alt="icon"
                      width="45"
                    />
                  </div>
                  <div style="flex-direction: column">
                    <div>
                      <span class="labelTwo"
                        >{{ $t("crossConnects.tipologia") }}
                        <span class="textTwo"> {{ item[0].tipo ?? "-" }}</span></span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="mdl-cell mdl-cell--12-col">
                <hr />
              </div>
            </div>
          </div>
        </div>

        <!-- XC -->
        <div class="contentRelatedServices" style="background-color: white">
          <div class="contentRef">
            <div class="summaryXC">
              <div class="mdl-grid">
                <div
                  class="mdl-cell mdl-cell--5-col boxXC mdl-cell--12-col-tablet mdl-cell--12-col-phone"
                  style="background-color: #e1e7ec"
                >
                  <div class="mdl-grid">
                    <div class="mdl-cell mdl-cell--12-col">
                      <h3>A-END</h3>
                      <hr />
                    </div>
                    <div class="mdl-cell mdl-cell--6-col title">
                      {{ $t("crossConnects.place") }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col value">
                      {{ item[0].aend_datacenter_name ?? "-" }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col title">
                      {{ $t("crossConnects.a_end_rack") }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col value">
                      {{ item[0].aend_rack_name ?? "-" }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col title">
                      {{ $t("crossConnects.a_end_unita") }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col value">
                      {{ item[0].aend_unita ?? "-" }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col title">
                      {{ $t("crossConnects.a_end_slot") }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col value">
                      {{ item[0].aend_slot ?? "-" }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col title">
                      {{ $t("crossConnects.a_end_fibre") }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col value">
                      {{ item[0].aend_fibre ?? "-" }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col title">
                      {{ $t("crossConnects.a_end_apparato") }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col value">
                      {{ item[0].aend_apparato ?? "-" }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col title">
                      {{ $t("crossConnects.patchPannelMMR") }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col value">
                      {{ item[0].mmr_port ?? "-" }}
                    </div>
                  </div>
                </div>
                <div class="mdl-cell mdl-cell--2-col"></div>
                <div
                  class="mdl-cell mdl-cell--5-col boxXC mdl-cell--12-col-tablet mdl-cell--12-col-phone"
                  style="background-color: #e1e7ec"
                >
                  <div class="mdl-grid">
                    <div class="mdl-cell mdl-cell--12-col">
                      <h3>B-END</h3>
                      <hr />
                    </div>
                    <div class="mdl-cell mdl-cell--6-col title">
                      {{ $t("crossConnects.z_end_sala") }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col value">
                      {{ item[0].zend_datacenter_name ?? "-" }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col title">
                      {{ $t("crossConnects.z_end_rack") }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col value">
                      {{ item[0].zend_rack_name ?? "-" }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col title">
                      {{ $t("crossConnects.z_end_unita") }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col value">
                      {{ item[0].zend_unita ?? "-" }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col title">
                      {{ $t("crossConnects.z_end_slot") }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col value">
                      {{ item[0].zend_slot ?? "-" }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col title">
                      {{ $t("crossConnects.z_end_fibre") }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col value">
                      {{ item[0].zend_fibre ?? "-" }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col title">
                      {{ $t("crossConnects.z_end_apparato") }}
                    </div>
                    <div class="mdl-cell mdl-cell--6-col value">
                      {{ item[0].zend_apparato ?? "-" }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
      </div>

      <div>
        <div
          class="contentButton"
          style="margin: 25px auto; text-align: center"
        >
          <router-link :to="'/' + $t('nav.crossConnectAttiveUrl')">
            <button class="cdlButton">
              {{ $t("crossConnects.backToList") }}
            </button>
          </router-link>
        </div>
      </div>

      <MyLoading :viewLoader="viewLoader" />
      <MyError
        :viewError="viewError"
        :message="$t('checkCoverageSummary.errorGeneric')"
      />
    </div>
  </div>
</template>

<script>
import MyLoading from "@/components/MyLoading.vue";
import MyHeaderPage from "@/components/MyHeaderPage.vue";
import "@/assets/scss/OrderNetworkCoverageSummary.scss";
import MyError from "@/components/MyError.vue";

export default {
  name: "CrossConnectDetail",
  components: {
    MyHeaderPage,
    MyLoading,
    MyError,
  },
  data() {
    return {
      item: {},
      IsMobile: this.$IsMobile,
      viewLoader: false,
      viewSubmit: true,
      viewError: false,
      messageError: "",
      he: {
        Accept: "application/json",
        Authorization: "Bearer " + this.$keycloak.idToken,
      },
    };
  },
  methods: {
    getCrossConnectDetail() {
      this.axios
        .get(
          `${this.$MyCrypto(
            window.VUE_APP_MISTRA_URL,
            1
          )}assets/v1/cross-connects/${this.$route.params.id}`,
          { headers: this.he }
        )
        .then((response) => {
          this.item = response.data;
          this.viewLoader = true;
          this.viewSubmit = false;
        })
        .catch((error) => {
          this.viewSubmit = false;
          this.viewError = true;
          this.messageError = error.message;
          setTimeout(() => {
            this.viewError = false;
          }, 5000);
        });
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getCrossConnectDetail();
  },
};
</script>
